// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_m3-0";
export var discountCodeInput = "_m3-1";